import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import * as EmailValidator from 'email-validator';
import { StaticImage } from 'gatsby-plugin-image'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setPopupRecord } from '../../../redux/actions'
import { logAmplitudeEvent } from '../../../services/amplitude'
import { logInWithGoogle, logInWithFacebook, signUpLocal } from '../../../services/auth'
import "./DiscountPopup.css"

const bear = {
  src: '../../../images/bear/dancing.png',
  alt: 'Buxbear dancing'
}
const bearSpecial = {
  src: '../../../images/bear/special.jpg',
  alt: 'Buxbear sitting down next to a package'
}
const signUpIconPaths = {
  google: '/icons/google.svg',
  facebook: '/icons/facebook.svg'
}
class DiscountPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPopupId: null
    }
    this.wrapRef = React.createRef()
  }
  toggleShowCustomEmail(to) {
    this.setState({
      showCustomEmail: to
    })
  }
  setFormValue(key, value) {
    this.setState({
      [key]: value
    })
  }
  formCompleted() {
    const { t } = this.props
    let formCompleted = true
    t(`login:createAccount.email.fields`, { returnObjects: true }).forEach(field => {
      if (
        !this.state[field.id] ||
        (field.validation === 'email' && !EmailValidator.validate(this.state[field.id])) ||
        (field.validation === 'confirmPassword' && (this.state[field.id]) !== this.state.password)
      ) {
        formCompleted = false
        document.querySelector(`#lp-input-${field.id}`).classList.add('missing')
      } else {
        document.querySelector(`#lp-input-${field.id}`).classList.remove('missing')
      }
    })
    return formCompleted
  }
  signUpWithCustomEmail() {
    if (this.formCompleted()) {
      const { firstName, lastName, email, password, phoneNumber } = this.state
      const { i18n } = this.props
      const accountInfo = {firstName, lastName, email, password, phoneNumber}
      accountInfo.preferredLanguage = i18n.language
      signUpLocal(
        accountInfo,
        null,
        () => {
          const { t } = this.props
          const messageEl = document.querySelector('.lp-message')
          messageEl.innerText = t(`login:createAccount.email.serverError`)
          messageEl.classList.add('warning')
        },
        true,
        () => {
          this.setState({
            done: true
          })
        }
      )
    }
  }
  dismissDiscountPopup(id = 'SignUp') {
    this.props.setPopupRecord(`discount${id}`, true)
    clearAllBodyScrollLocks()
  }
  processNextPopup() {
    const { location, popupRecords } = this.props
    const popupList = [
      location && location.url_name === 'colorado-self-storage' && 'Colorado',
      'SignUp'
    ]
    let nextPopup = null
    let currentPopupIndex = 0
    while (!nextPopup && currentPopupIndex < popupList.length) {
      const popupId = popupList[currentPopupIndex]
      if (popupId && !popupRecords[`discount${popupId}`]) {
        nextPopup = popupId
      }
      currentPopupIndex ++
    }
    this.setState({
      showPopupId: nextPopup
    }, () => {
      nextPopup && disableBodyScroll(this.wrapRef.current)
    })
  }
  componentDidMount() {
    this.processNextPopup()
  }
  componentDidUpdate(prevProps) {
    const { popupRecords } = this.props
    const { showPopupId } = this.state
    const recordId = `discount${showPopupId}`
    if (popupRecords[recordId] !== prevProps.popupRecords[recordId]) {
      this.processNextPopup()
    }
  }
  render() {
    const { t } = this.props
    const { 
      showCustomEmail, 
      done, 
      showPopupId
    } = this.state
    return (
      <div className="discount-popup-wrap" ref={this.wrapRef}>
        {showPopupId === 'Colorado' && (
          <div className="dialog-wrap">
            <div role="button" tabIndex="0" className="dialog-background" onClick={() => this.dismissDiscountPopup('Colorado')} />
            <div className="dialog-content">
              <div role="button" tabIndex="0" className="dialog-close-button" onClick={() => this.dismissDiscountPopup('Colorado')} >
                <div className="dialog-close-line line-1" />
                <div className="dialog-close-line line-2" />
              </div>
              <div className="dd-inner-wrap special">
                <StaticImage 
                  className="dd-bear special"
                  loading="eager" 
                  placeholder="none"
                  objectFit="contain"
                  {...bearSpecial} 
                />
                <h3 className="dialog-text">Move-In Special!</h3>
                <p className="dialog-text">$20 first month’s rent for any unit, any size, when you enter the below discount code at checkout:</p>
                <p className="dialog-text bold">3FBCAC6CA663</p>
              </div>
            </div>
          </div>
        )}
        {showPopupId === 'SignUp' && (
          <div className="dialog-wrap">
            <div role="button" tabIndex="0" className="dialog-background" onClick={() => this.dismissDiscountPopup()} />
            <div className="dialog-content discount-dialog">
              <div role="button" tabIndex="0" className="dialog-close-button" onClick={() => this.dismissDiscountPopup()} >
                <div className="dialog-close-line line-1" />
                <div className="dialog-close-line line-2" />
              </div>
              {!done && !showCustomEmail && (<div className="dd-inner-wrap">
                <StaticImage 
                  className="dd-bear"
                  loading="eager" 
                  placeholder="none"
                  objectFit="contain"
                  objectPosition="bottom"
                  {...bear} 
                />
                <h3 className="dialog-text bold">
                  {t(`landing:discountPopup.text`)}
                </h3>
                <div className="dd-sign-up-wrap">
                  <button
                    className="sign-up-button facebook"
                    onClick={() => logInWithFacebook(`${process.env.FRONTEND_URL}account-created`, true)}
                  >
                    <img className="login-sign-up-icon" src={signUpIconPaths.facebook} alt="Facebook logo" />
                    {t(`login:createAccount.thirdParty.facebook`)}
                  </button>
                  <button
                    className="sign-up-button google"
                    onClick={() => logInWithGoogle(`${process.env.FRONTEND_URL}account-created`, true)}
                  >
                    <img className="login-sign-up-icon" src={signUpIconPaths.google} alt="Google logo" />
                    {t(`login:createAccount.thirdParty.google`)}
                  </button>
                  <button className="sign-up-button" onClick={() => this.toggleShowCustomEmail(true)}>
                    {t(`login:createAccount.email.triggerButton`)}
                  </button>
                </div>
              </div>)}
              {!done && showCustomEmail && (
                <div className="dd-inner-wrap wide">
                  <p className="lp-message">
                    {t(`login:createAccount.email.message`)}
                  </p>
                  {t(`login:createAccount.email.fields`, {returnObjects: true}).map(field => {
                    return [
                      <label
                        key={field.id + '1'}
                        className="lp-label"
                      >
                        {field.placeholder}
                      </label>,
                      <input
                        key={field.id}
                        id={`lp-input-${field.id}`}
                        className="lp-input"
                        type={field.type}
                        onChange={(e) => this.setFormValue(field.id, e.target.value)}
                      />
                    ]
                  })}
                  <button className="lp-email-sign-up-button" onClick={() => this.signUpWithCustomEmail()}>
                    {t(`login:createAccount.email.submit`)}
                  </button>
                </div>
              )}
              {done && (
                <p className="lp-message">
                  {t(`landing:discountPopup.done`)}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}
const mapStateToProps = state => ({
  popupRecords: state.meta.popupRecords
})
const mapDispatchToProps = dispatch => ({
  setPopupRecord: (id, to) => dispatch(setPopupRecord(id, to))
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(['landing', 'login'])(DiscountPopup))
